<template>
  <div class="hello">
    <br>
    {{ msg }}
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
div {
  font-family: juicy;
  font-size: 50px;
}

@font-face {
        font-family: juicy;
        src: url('/fonts/04B_30__.TTF');
}
</style>
